import { prototypeIntakeNotes } from '../assets/prototypeIntakeNotes'
import { prototypePlacementReason } from '../assets/prototypePlacementReason'
import { prototypeGroupFollowup } from '../assets/prototypeGroupFollowup'
import { prototypeStep3 } from '../assets/prototypeStep3'
import { prototypeStep4 } from '../assets/prototypeStep4'
import { HowItWorksStep } from '../types/homepage'

export const howItWorksSteps: HowItWorksStep[] = [
  {
    shortLabel: 'Tell your story',
    title: 'Tell your story with Joy',
    description:
      'Talk or type with Joy while care notes take shape alongside the conversation. Review, edit, or hide each note, and choose what to share with your care team.',
    screen: {
      src: prototypeIntakeNotes,
      alt: 'Client prototype screen showing a conversation with Joy alongside care notes, with options to review, edit, or hide each note and choose what to share with the care team.',
      caption: 'Your conversation and care notes, side by side.',
    },
  },
  {
    shortLabel: 'Find your fit',
    title: 'Find your group and therapist',
    description:
      'Share your story and goals, then review a match that considers fellow participants, relevant demographics and life stage, therapist expertise, and the therapeutic modality and approach best suited to your needs.',
    screen: {
      src: prototypePlacementReason,
      alt: 'Client prototype screen showing a “Why this placement” pop-over that explains why a therapist and group may be a good fit.',
      caption: 'See why this therapist and group may fit.',
    },
  },
  {
    shortLabel: 'Work together',
    title: 'Work toward goals together',
    description:
      'Meet online with your therapist and group for guided conversations, practical exercises, and shared learning. Set clear goals and objectives, with support from your therapist and peers as you work toward them. Between sessions, try optional practices and celebrate small wins with your group.',
    screen: {
      src: prototypeGroupFollowup,
      alt: 'Client prototype screen showing a “From your group session” follow-up with optional practices, and a “Celebrations from your group” area for sharing small wins.',
      caption: 'Carry the session forward and share small wins.',
    },
  },
  {
    shortLabel: 'Understand progress',
    title: 'Understand your progress',
    description:
      'Review progress with your therapist using clinical outcome measures alongside your own goals and reflections. Together, use that picture to understand what’s changing and where support or a different approach may help.',
    screen: {
      src: prototypeStep3,
      alt: 'Client prototype screen introducing the GAD-7 clinical check-in, with options to answer with Joy or complete the form independently.',
      caption: 'Clinical check-ins add context to your progress.',
    },
  },
  {
    shortLabel: 'Choose next',
    title: 'Choose what comes next',
    description:
      'As your goals evolve or a group comes to a close, explore your next step. You can continue with a new group, work toward new goals, or consider a different approach with support in finding the right fit.',
    screen: {
      src: prototypeStep4,
      alt: 'Client prototype screen showing a personal care pathway with options to get support in adjusting care.',
      caption: 'Explore your pathway and discuss what comes next.',
    },
  },
]
